import {
	Component,
	EventEmitter,
	Input,
	Output,
	ViewChild
} from '@angular/core';

import { SecondMs } from 'rev-shared/date/Time.Constant';

import { IPulseTimelineEntry } from './IPulseTimelineEntry';
import { PulseTimelineEntryType } from './PulseTimelineEntryType';

import { VbConfirmationDialogComponent } from 'rev-shared/ui/dialog/VbConfirmationDialogAngular.Component';

import styles from './PulseTimelineEntry.module.less';

@Component({
	selector: 'pulse-timeline-entry',
	templateUrl: './PulseTimelineEntry.Component.html',
	host: {
		'[class]': 'styles.root'
	}
})
export class PulseTimelineEntryComponent {
	@Input() public isActive: boolean;
	@Input() public entry: IPulseTimelineEntry;
	@Input() public openedEdit: IPulseTimelineEntry;
	@Input() public showHours: boolean;
	@Input() public canEdit: boolean;
	@Input() public dropup: boolean;

	@Output() public onSelect = new EventEmitter<IPulseTimelineEntry>();
	@Output() public onEdit = new EventEmitter<IPulseTimelineEntry>();
	@Output() public onEditToggled = new EventEmitter<IPulseTimelineEntry>();

	@ViewChild(VbConfirmationDialogComponent) public deleteConfirmation: VbConfirmationDialogComponent;

	public readonly SecondMs = SecondMs;
	public readonly styles = styles;

	public get entryDurationMs(): number {
		return (this.entry.endSecs - this.entry.startSecs) * SecondMs;
	}

	public get isTaggedUser(): boolean {
		return this.entry.type === PulseTimelineEntryType.TAGGED_USER;
	}

	public get isTaggedUserWithoutRange(): boolean {
		return this.entry.startSecs + this.entry.endSecs === 0;
	}

	public get isTranscription(): boolean {
		return this.entry.type === PulseTimelineEntryType.TRANSCRIPTION;
	}

	public onClick(): void {
		this.onSelect.emit(this.entry);
	}

	public saveSubtitle(entry: IPulseTimelineEntry): void {
		this.onEdit.emit(entry);
	}

	public deleteSubtitle(entry: IPulseTimelineEntry): void {
		this.deleteConfirmation.open().result
			.then(() => {
				this.onEdit.emit(entry);
			})
			.catch(() => console.log('Delete was canceled'));
	}
}
